import {Component} from '@angular/core';
import {Components} from "@gen-nexus-registry/grid-lib";
import {MessagesService} from "../../services/messages.service";
import GridToast = Components.GridToast;

export interface Message {
  text: string,
  type: GridToast["type"]
}

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent {
  constructor(public messagesService: MessagesService) {
  }

  getIconaMessaggio(message: Message) {
    switch (message.type) {
      case "success":
        return "checkmark-circle"
      case "error":
        return "alert-circle"
      case "warning":
        return "warning"
      case "loading":
        return ""
    }
  }
}
